import React, { Component } from 'react';
import BusinessSignupView from './BusinessSignupView';
import config from '../../config';

class BusinessSignupContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      error: null,
    };
  }

  onSubmit = async values => {
    this.setState({ loading: true, error: null });
    try {
      const res = await fetch(`${config.BASE_URL}/businesses/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });
      const json = await res.json();
      if (res.ok) {
        this.setState({ loading: false, success: true });
      } else {
        const msg = json?.message ?? json?.error?.message ?? 'Signup failed. Please try again.';
        this.setState({ loading: false, error: Array.isArray(msg) ? msg.join(', ') : msg });
      }
    } catch (e) {
      this.setState({ loading: false, error: 'Network error. Please try again.' });
    }
  };

  render() {
    const { loading, success, error } = this.state;
    return (
      <BusinessSignupView
        onSubmit={this.onSubmit}
        loading={loading}
        success={success}
        error={error}
      />
    );
  }
}

export default BusinessSignupContainer;
